enum ResponseEnum {
	OK = 'OK'
}

export default ResponseEnum